import React from 'react'
import { ChevronDown } from 'lucide-react'

export interface SelectOption {
  value: string
  label: string
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options?: SelectOption[]
  children?: React.ReactNode
  className?: string
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, children, className = '', disabled, ...rest }, ref) => {
    const selectClasses = [
      'w-full px-4 py-3 bg-white border border-silver/60 rounded-warm font-body text-ink',
      'appearance-none cursor-pointer',
      'transition-all duration-200',
      'focus:border-green focus:ring-2 focus:ring-green/20 outline-none',
      disabled ? 'opacity-50 cursor-not-allowed bg-silver-light/50' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div className="w-full">
        {label && (
          <label className="block font-body text-sm font-medium text-ink-light mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          <select ref={ref} disabled={disabled} className={selectClasses} {...rest}>
            {options
              ? options.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))
              : children}
          </select>
          <ChevronDown
            size={18}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-muted pointer-events-none"
          />
        </div>
      </div>
    )
  }
)

Select.displayName = 'Select'

export default Select
